/**
 * Termin-Datumsfelder auf `users` mit zugehöriger Uhrzeit-Spalte (TIME,
 * NULL = ganztägig). Backend: Migration 2026_09_28_100000, Kalender-Spiegel
 * über TerminFeldSync (mit Uhrzeit → Termin 60 Min., sonst ganztägig).
 */
export const TERMIN_TIME_FIELDS = {
  anamnese_termin_am: 'anamnese_termin_um',
  beratungsgespraech_am: 'beratungsgespraech_um',
} as const;

export type TerminDateField = keyof typeof TERMIN_TIME_FIELDS;
export type TerminTimeField = typeof TERMIN_TIME_FIELDS[TerminDateField];
export type TerminField = TerminDateField | TerminTimeField;

/** TIME-Wert ("14:30:00" oder "14:30") → "HH:MM" für <input type="time">. */
export function toTimeInput(v: unknown): string {
  return typeof v === 'string' && /^\d{2}:\d{2}/.test(v) ? v.slice(0, 5) : '';
}
